import { Stack, useLocalSearchParams } from "expo-router";

/**
 * Preserve the recital overview behind a directly opened performance or dancer route.
 * Together with the Recitals browse anchor, a cold link constructs the same
 * Recitals → Show → child hierarchy as ordinary in-app navigation.
 */
export const unstable_settings = {
  initialRouteName: "index"
};

export default function ShowLayout() {
  const { studioSlug, recitalSlug } = useLocalSearchParams<{
    studioSlug: string;
    recitalSlug: string;
  }>();

  return (
    <Stack
      screenOptions={{
        contentStyle: { backgroundColor: "transparent" },
        headerShown: false,
        orientation: "portrait",
        statusBarStyle: "light"
      }}
    >
      <Stack.Screen name="index" initialParams={{ studioSlug, recitalSlug }} />
    </Stack>
  );
}
